import { render, staticRenderFns } from "./FileProgress.vue?vue&type=template&id=0befc3d9&"
import script from "./FileProgress.vue?vue&type=script&lang=js&"
export * from "./FileProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports